var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 55 65",
    width: "55pt",
    height: "65pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_tjKBwiCD2lP26wBU9gDZFUZFtLFBL62R"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_tjKBwiCD2lP26wBU9gDZFUZFtLFBL62R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 35.542 3.283 C 34.362 2.104 32.778 1.452 31.133 1.452 L 8.871 1.452 C 5.456 1.452 2.661 4.246 2.661 7.661 L 2.661 57.339 C 2.661 60.754 5.425 63.548 8.84 63.548 L 46.129 63.548 C 49.544 63.548 52.339 60.754 52.339 57.339 L 52.339 22.658 C 52.339 21.012 51.687 19.429 50.507 18.28 L 35.542 3.283 Z  M 30.605 6.109"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaper);
export default __webpack_public_path__ + "static/media/IconPaper.f950b7f1419f40101fb4571c91084cc5.svg";
export { ForwardRef as ReactComponent };